import { Component, Input, OnInit, Provider } from '@angular/core';
import { CommonService, Config } from 'huddyapi';

import moment_ from 'moment';
import { SavedProvider } from '../settings.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';



const moment = moment_;

@Component({
  selector: 'provider-cleaner',
  templateUrl: './provider-cleaner.html',
  styleUrls: ['./provider-cleaner.scss']
})
export class ProviderCleaner implements OnInit {

  @Input() providers : SavedProvider[];
  selected : number;

  constructor(
    private http: HttpClient,
    private sharedService: CommonService,
     private config: Config
  ) {


  }

  cleanIt() {
    console.log('cleanIt', 'providerId', this.selected);
    const params = new HttpParams()
    .append('providerId', ''+this.selected);
    this.http.get(this.config.getEndpoint() + '/cleanup-provider',  {
      headers: this.sharedService.getAuthenticationHeaders().append('allowDupes', 'true'),
     params: params}).pipe(map((response: any)  => console.log(response), (error: any) => {
      throw error;
    })).subscribe();
  
  }

  ngOnInit(): void {
    console.log('Provider cleaner', this.providers);
  }





}